module.exports = __webpack_public_path__ + "files/309c6aca30f5dfabfcf423aaddb3063b.png";